import { render, staticRenderFns } from "./photoUpload_button_component.vue?vue&type=template&id=4365d864&"
import script from "./photoUpload_button_component.vue?vue&type=script&lang=js&"
export * from "./photoUpload_button_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports